<div *ngIf="registration != undefined && registration.id != undefined"
    (click)="showList = false; $event.stopPropagation();" class="row fields-group no-filter faded">
    <div class="col-12">
        <div class="list-title d-flex">
            <span class="d-flex w-100 pr-1 title cursor-pointer" (click)="isCollapsed = !isCollapsed">
                {{ 'reg.costs' | translate }} ({{costs && costs.length ? costs.length : '0'}})
                <span *ngIf="costs?.length > 0" class="list-header-collapse-toggle ml-auto">
                    <i class="fa fa-angle-{{isCollapsed ? 'down' : 'up'}}"></i>
                </span>
            </span>
        </div>
        <div class="row p-0 m-0 page-table expanded-list" *ngIf="!isCollapsed">
            <div class="list-group-collapse duo flex-wrap list-item-container" cdkDropList [cdkDropListData]="costs"
                (cdkDropListDropped)="dropped($event)">
                <div cdkDrag *ngFor="let regCost of costs; let first = first; let last = last; let i = index;"
                    class="{{ disabled ? 'list-item-disabled' : 'list-item' }} {{first ? 'first' : ''}} item">
                    <div (click)="openEdit(regCost);$event.stopPropagation();"
                        class="d-flex justify-content-between col">
                        <div class="d-flex align-items-center w-100">
                            <span>{{regCost?.name}}</span>
                        </div>
                        <div class="d-flex align-items-center">
                            <small
                                *ngIf="regCost && regCost.costType !== CostType.PERCENTAGE && regCost.costType !== CostType.FORMULA && regCost.currency"
                                class="mb-0 ml-5">{{regCost.currency.code}}</small>
                            <strong *ngIf="regCost && regCost.costType !== CostType.FORMULA" class="mb-0">
                                <span
                                    *ngIf="regCostCurrencies && regCostCurrencies[regCost.id] && regCostCurrencies[regCost.id].isPrefix">{{regCostCurrencies[regCost.id].name}}</span>
                                {{regCost?.formattedValue}}
                                <span
                                    *ngIf="regCostCurrencies && regCostCurrencies[regCost.id] && !regCostCurrencies[regCost.id].isPrefix">{{regCostCurrencies[regCost.id].name}}</span>
                            </strong>
                            <small *ngIf="regCost && regCost.costType === CostType.PERCENTAGE" class="mb-0">%</small>
                            <span tooltip="{{'Formula' | translate }}"
                                *ngIf="regCost && regCost.costType === CostType.FORMULA"
                                class="btn-circle-icon btn-circle-small btn-formula mr-1">F</span>
                        </div>
                        <div class="d-flex align-items-center"
                            (click)="openEdit(regCost, true); $event.stopPropagation();">
                            <det-popover [extraClasses]="hasDeterminant(regCost) ? 'active' : ''"
                                [determinant]="regCost.jsonDeterminants" [hasErrors]="hasError(regCost.id)"
                                [placement]="'top'" [determinantMapById]="determinantMapById"></det-popover>
                        </div>
                        <div class="d-flex align-items-center">
                            <business-key *ngIf="regCost.businessKey" class="mr-auto"
                                [businessKey]="regCost.businessKey"
                                [businessKeyTooltip]="'Cost business key' | translate" [extraClass]="'mr-2'">
                            </business-key>
                        </div>
                        <div class="d-flex align-items-center" *ngIf="!disabled">
                            <confirmation [showTrashIcon]="true" [question]="'confirm.areyousure'"
                                [extraClasses]="'d-flex'" (click)="$event.stopPropagation();"
                                (isConfirmed)="deleteCost($event, regCost.id, i)"></confirmation>
                        </div>
                    </div>
                    <div *cdkDragPreview class="col-4">
                        <div>
                            {{regCost?.name}}
                        </div>
                    </div>
                </div>
            </div>
            <button *ngIf="!disabled" (click)="openEdit(null, false);$event.stopPropagation();"
                class="btn btn-sm btn-default mt-2">{{'Add new' | translate}}</button>
        </div>
    </div>
</div>